import { render } from "./TheNhaHang.vue?vue&type=template&id=19068142"
import script from "./TheNhaHang.vue?vue&type=script&lang=js"
export * from "./TheNhaHang.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__